<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">Fournisseurs</h2>
            </header>
            <div class="panel-body">
              <div class="row">
                <div class="col-xl-12 mb-md">
                  <label  style="float:left;margin-right:10px;"><input v-bind:value="keywords" v-on:input="debounceSearch($event.target.value)" class="form-control" placeholder="recherche" aria-controls="listing-datatable"></label>
                  <label style="float:left;margin-right:10px;">
                    <select v-model="agency_status" v-on:change="newStart('agency_status')" class="form-control" style='max-width:200px'>
                      <option disabled value="">Statut du fournisseur</option>
                      <option value="">Tous</option>
                      <option v-for="option in agency_status_options" v-bind:value="option.agency_status_id" :key="option.agency_status_id">
                        {{ option.agency_status }}
                      </option>
                    </select>
                  </label>
                  <label style="float:left;margin-right:10px;">
                    <select v-model="plans_status" v-on:change="newStart('plans_status')" class="form-control" style='max-width:150px'>
                      <option disabled value="">Statut du plan</option>
                      <option value="">Tous</option>
                      <option v-for="option in plans_status_options" v-bind:value="option.plans_status_id" :key="option.plans_status_id">
                        {{ option.plans_status }}
                      </option>
                    </select>
                  </label>
                  <label style="float:left;margin-right:10px;">
                    <select v-model="responsable" v-on:change="newStart('reponsable')" class="form-control" style='max-width:150px'>
                      <option disabled value="">Responsable</option>
                      <option value="">Tous</option>
                      <option v-for="option in responsable_options" v-bind:value="option.user_id" :key="option.user_id">
                        {{ option.responsable_name }}
                      </option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="table-responsive">
                <GridGeneral
                :data="workplans"
                :columns="gridColumns"
                :sortColumns="gridColumnsSort"
                :loadData="refresh">
                </GridGeneral>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
</template>
<script>

import axios from 'axios';
import GridGeneral from '@/components/GridGeneral.vue'


export default {
  data: function() {return {
    keywords:'',
    agency_status:'',
    plans_status:'',
    responsable:'',
    agency_status_options:{},
    plans_status_options:{},
    responsable_options:{},
    workplans: {},
    gridColumns: [{field:'agency',title:'Fournisseur'},{field:'rliss',title:'RLISS'},{field:'plans_status',title:'Satut du rapport'},{field:'agency_status',title:'Statut du fournisseur'},{field:'responsable',title:'Responsable'},{field:'state',title:'État'}],
    gridColumnsSort : ['agency','rliss','plans_status','agency_status','responsable','state'],
    sort:'',
    sortOrder:1,
    superadmin:false,
  }},

  name: 'ServiceProviderList',
  components: {
    GridGeneral,
  },
  methods: {

    debounceSearch: function(val){
      this.keywords = val;
      if(this.search_timeout) clearTimeout(this.search_timeout);
      const self = this;
      this.search_timeout = setTimeout(function() {

        self.startRow = 0;
      self.refresh();
      }, 200);
    },

    newStart:  function () {

      this.refresh();
      this.loadFilters();
    },

    loadFilters: function () {

      axios
        .get(this.$root.$data.server_base + '/api/service_provider_dropdown.php',
          { params:{entity:this.entity}})
        .then(response => (this.agency_status_options = response.data.agency_status, this.plans_status_options = response.data.plans_status,this.responsable_options = response.data.responsable))

    },


    refresh: function() {

      this.startRow = 0;
      this.fromRow = 1;
      axios
        .get(this.$root.$data.server_base + '/api/service_providers.php',
          { params: {agency_status:this.agency_status,plans_status:this.plans_status,responsable:this.responsable,keywords:this.keywords,sort:this.sort,sortOrder:this.sortOrder}})
        .then(response => (
          this.workplans = response.data.workplans,
          this.superadmin = response.data.superadmin,
          this.columns()
          ))
    },

    columns: function () {
      if(this.superadmin)
      {
        this.gridColumns = [{field:'agency',title:'Fournisseur'},{field:'rliss',title:'RLISS'},{field:'plans_status',title:'Satut du rapport'},{field:'agency_status',title:'Statut du fournisseur'},{field:'responsable',title:'Responsable'},{field:'state',title:'État'}];
        this.gridColumnsSort = ['agency','rliss','plans_status','agency_status','responsable','state'];
      }
      else
      {
        this.gridColumns = [{field:'agency',title:'Fournisseur'},{field:'rliss',title:'RLISS'},{field:'plans_status',title:'Satut du rapport'},{field:'agency_status',title:'Statut du fournisseur'},{field:'responsable',title:'Responsable'}];
        this.gridColumnsSort = ['agency','rliss','plans_status','agency_status','responsable'];
      }
    },

  },
  mounted () {
    this.refresh();
    this.loadFilters();
  }
}
</script>
